import { SpriteMaterial, Vector4 } from "three";
import { Shaders } from "../shaders";
import { mySetValuesImpl } from "./index";
export class LabelCollectionMaterial extends SpriteMaterial {
    constructor(parameters) {
        var _a, _b, _c, _d, _e, _f, _g;
        super(parameters);
        this.glyphScale = (_a = parameters.glyphScale) !== null && _a !== void 0 ? _a : 0.001;
        this.sdfExponent = (_b = parameters.sdfExponent) !== null && _b !== void 0 ? _b : 9;
        this.fillColor = (_d = (_c = parameters.fillColor) === null || _c === void 0 ? void 0 : _c.clone()) !== null && _d !== void 0 ? _d : new Vector4(1, 1, 1, 1);
        this.strokeColor = (_f = (_e = parameters.strokeColor) === null || _e === void 0 ? void 0 : _e.clone()) !== null && _f !== void 0 ? _f : new Vector4(0, 0, 0, 1);
        this.strokeWidth = (_g = parameters.strokeWidth) !== null && _g !== void 0 ? _g : 0;
        this.transformAtlas = parameters === null || parameters === void 0 ? void 0 : parameters.transformAtlas;
    }
    setValues(parameters) {
        return mySetValuesImpl(this, parameters);
    }
    copy(material) {
        super.copy(material);
        if (material instanceof LabelCollectionMaterial) {
            this.glyphScale = material.glyphScale;
            this.sdfExponent = material.sdfExponent;
            this.fillColor = material.fillColor;
            this.strokeColor = material.strokeColor;
            this.strokeWidth = material.strokeWidth;
            this.transformAtlas = material.transformAtlas;
        }
        return this;
    }
    onBeforeCompile(shader, renderer) {
        super.onBeforeCompile(shader, renderer);
        shader.vertexShader = Shaders.glyph.vertex;
        shader.fragmentShader = Shaders.glyph.fragment;
        shader.uniforms.skGlyphScale = {
            value: this.glyphScale,
        };
        shader.uniforms.skGlyphTransformAtlas = {
            value: this.transformAtlas,
        };
        shader.uniforms.uSkSDFExponent = {
            value: this.sdfExponent,
        };
        shader.uniforms.uSkFillColor = {
            value: this.fillColor,
        };
        shader.uniforms.uSkStrokeColor = {
            value: this.strokeColor,
        };
        shader.uniforms.uSkStrokeWidth = {
            value: this.strokeWidth,
        };
    }
    customProgramCacheKey() {
        return `:
        ${this.version}
        `;
    }
}
